import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import DisparoSettings from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/disparo'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'settings_disparo_index',
          component: DisparoSettings,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
